import { gsap } from 'gsap'
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin'
import { MotionPathPlugin } from 'gsap/MotionPathPlugin'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(MotionPathPlugin, ScrollTrigger, DrawSVGPlugin)

document.addEventListener('DOMContentLoaded', () => {
    new scrollyTelling()
})

export default class scrollyTelling {
    //-----------------------------------//
    // Config
    //----------------------------------//

    //Style for steps
    static stepNameColor = '#000'
    static stepBgColor = '#fff'
    static stepBorderColor = '#b9906a'
    static stepBorderWidth = '1'

    //Style for current step
    static currentStepNameColor = '#000'
    static currentStepBgColor = '#fff'
    static currentStepBorderColor = '#b9906a'
    static currentStepBorderWidth = '2'

    constructor() {
        scrollyTelling.initializeDrawPathTest()
    }

    static initializeDrawPathTest() {
        const mapContainer = '#scrollytellingMap'
        const stepSection = $('.scrollytellingStep')
        const map = document.getElementById('svg-map')
        const mapWidth = map.getBoundingClientRect().width
        const mapHeight = map.getBoundingClientRect().height
        const stops = gsap.utils.toArray('#points circle')
        const stopsName = gsap.utils.toArray('#nom_points g')

        let step = 1
        let ratioX = $(map).attr('data-ratio-x')
        let ratioY = $(map).attr('data-ratio-y')
        const initPosXPercent = $(map).attr('data-pos-x-percent')
        const initPosYPercent = $(map).attr('data-pos-y-percent')

        if (window.matchMedia('(max-width: 1480px)').matches) {
            ratioX = $(map).attr('data-ratio-x-large')
            ratioY = $(map).attr('data-ratio-y-large')
        }

        gsap.set(mapContainer, {
            position: 'fixed',
            width: mapWidth,
            height: mapHeight,
            transformOrigin: '0 0',
            left: window.innerWidth / 2,
            top: window.innerHeight / 2,
            xPercent: initPosXPercent,
            yPercent: initPosYPercent,
            autoAlpha: 1,
        })

        gsap.set(stops[0], {
            fill: scrollyTelling.currentStepBgColor,
            stroke: scrollyTelling.currentStepBorderColor,
            'stroke-width': scrollyTelling.currentStepBorderWidth,
        })
        gsap.set(stopsName[0], { fill: scrollyTelling.currentStepNameColor })

        //Init scroll
        $(stepSection).each(() => {
            const section = $(`.scrollytellingStep-${step}`)
            const path = `#trail-path-${step}`

            gsap.timeline({
                defaults: {
                    ease: 'none',
                    duration: 1,
                },
                scrollTrigger: {
                    trigger: section,
                    start: 'top 40%',
                    end: `+=${section.height() + 40}`,
                    scrub: true,
                    markers: false,
                },
            })
                .to(
                    '#marker',
                    {
                        motionPath: {
                            path,
                            align: path,
                            alignOrigin: [0.5, 0.5],
                        },
                    },
                    0,
                )
                .from(path, { ease: 'none', drawSVG: '0 0', duration: 1 }, 0.006)
                .set(stops[step], {
                    fill: scrollyTelling.currentStepBgColor,
                    stroke: scrollyTelling.currentStepBorderColor,
                    'stroke-width': scrollyTelling.currentStepBorderWidth,
                })
                .set(stopsName[step], { fill: scrollyTelling.currentStepNameColor })
                .set(stops[step - 1], {
                    fill: scrollyTelling.stepBgColor,
                    stroke: scrollyTelling.stepBorderColor,
                    'stroke-width': scrollyTelling.stepBorderWidth,
                })
                .set(stopsName[step - 1], { fill: scrollyTelling.stepNameColor })

            step++
        })

        const povDelay = 1 // 1 = no delay
        const pos = { x: -mapWidth / 2, y: -mapHeight / 2 }
        const xSet = gsap.quickSetter(mapContainer, 'x', 'px')
        const ySet = gsap.quickSetter(mapContainer, 'y', 'px')

        gsap.ticker.add(() => {
            pos.x += (-gsap.getProperty('#marker', 'x') - pos.x + (pos.x * ratioX) / 100) * povDelay
            pos.y += (-gsap.getProperty('#marker', 'y') - pos.y + (pos.y * ratioY) / 100) * povDelay
            xSet(pos.x)
            ySet(pos.y)
        })
    }
}
